
import { defineComponent } from 'vue';
import DigitalAssetUpload from '../../components/DigitalAssetUpload.vue';

export default defineComponent({
    name: "Zone Image",
    data: ()=>({
        content: { } as any,
        zoneImageUpload: null as File | null,
    }),

    components: {
        DigitalAssetUpload
    },

    props: {
        zoneContent: {
            type: Object,
            default: null
        },
        zoneNumber: {
            type: Number,
            default: null
        },
        zoneType: {
            type: String,
            default: null
        },
        contentName: {
            type: String,
            default: null
        },
        zoneHeight: {
            type: Number,
            default: null
        },
        zoneWidth: {
            type: Number,
            default: null
        }
    },

    computed: {
        assetUrl() {
            if(this.content.image && this.content.image.url) {
                return this.content.image.url;
            }
            else {
                return '/images/ditto-icon.png';
            }
        },

        imageSizeText() {
            return `Zone dimensions are ${this.zoneWidth}px x ${this.zoneHeight}px.`
        }
    },

    async created() {
        this.content = {
            image: this.zoneContent && this.zoneContent.content.image ? this.zoneContent.content.image : undefined,
        }
    },

    watch: {
        'zoneImageUpload': {
            handler (newValue: any) {
                this.content.imageFile = newValue;
                this.$emit('updateSignageZones', {zoneNumber: this.zoneNumber, zoneType: this.zoneType, updatedContent: this.content});
            },
            deep: true
        }
    }
})
